import React, {PureComponent} from 'react';
// import ReactGA from "react-ga";
import {Intent, PopoverInteractionKind, Position, Popover, Switch} from '@blueprintjs/core/lib/esm/index';
import {Button, MenuItem} from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import toastr from 'toastr';
import {getJwt} from '../../../services/authService';
import http from '../../../services/httpService';
import InputRegular from '../../common/InputRegular';
import StripeReplacementModal from '../../modals/StripeReplacementModal';

class BillingPreferences extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            selectedSource: '',
            error: '',
            autoTopUp: false,
            autoTopUpBackend: false,
            autoTopUpSave: false,
            balanceWarning: false,
            balanceWarningBackend: false,
            balanceWarningSave: false,
            topUpLimit: 2000,
            topUpWith: 2000,
            balanceWarningLimit: '',
            notifyMeBy: 'Email & SMS',
            fieldsCheckActive: false,
            fieldsCheckActive2: false,
            errorsList: [],
            errorsList2: [],
            projectBalance: '',
            stripeReplacementModal: false
        };
    }

    componentDidMount() {
        //   ReactGA.pageview(window.location.pathname + window.location.search);
        if (this.props.selectedSource) {
            // console.log('projectBalance: ', this.props.projectBalance)
            this.setState({
                selectedSource: this.props.selectedSource,
                autoTopUp: this.props.projectBalance && this.props.projectBalance.top_up_enabled ? true : false,
                projectBalance: this.props.projectBalance,
                topUpWith: this.props.projectBalance && this.props.projectBalance.top_up_amount ? this.props.projectBalance.top_up_amount : 50,
                topUpLimit: this.props.projectBalance ? this.props.projectBalance.balance_threshold : 20
            })
        }

        if (this.props.location && this.props.location.state && this.props.location.state.shouldUpdateUserData) {
            this.setState({
                selectedSource: this.props.selectedSource,
                autoTopUp: this.props.projectBalance && this.props.projectBalance.top_up_enabled ? true : false,
                projectBalance: this.props.projectBalance,
                topUpWith: this.props.projectBalance && this.props.projectBalance.top_up_amount ? this.props.projectBalance.top_up_amount : 50,
                topUpLimit: this.props.projectBalance ? this.props.projectBalance.balance_threshold : 20
            })
        }
    }

    componentDidUpdate() {
        if (
            (this.state.selectedSource !== this.props.selectedSource) ||
            (!this.state.projectBalance && this.props.projectBalance) ||
            (this.props.location && this.props.location.state && this.props.location.state.shouldUpdateUserData &&
                (this.state.projectBalance.top_up_enabled !== this.props.projectBalance.top_up_enabled))
        ) {
            // console.log('projectBalance: ', this.props.projectBalance)
            this.setState({
                selectedSource: this.props.selectedSource,
                autoTopUp: this.props.projectBalance && this.props.projectBalance.top_up_enabled ? true : false,
                projectBalance: this.props.projectBalance || '',
                topUpWith: this.props.projectBalance && this.props.projectBalance.top_up_amount ? this.props.projectBalance.top_up_amount : 50,
                topUpLimit: this.props.projectBalance ? this.props.projectBalance.balance_threshold : 20
            })
        }
    }

    handleAutoTopUpChange = async () => {
        await this.setState({autoTopUp: !this.state.autoTopUp, autoTopUpSave: true})
        if (!this.state.autoTopUp) {
            this.setState({
                fieldsCheckActive: false,
                errorsList: []
            })
        }
        // if (this.state.autoTopUp !== this.state.autoTopUpBackend){
        //     await this.setState({autoTopUpSave: true})
        // } else if (this.state.autoTopUp === this.state.autoTopUpBackend){
        //     await this.setState({autoTopUpSave: false})
        // }
    }
    handleBalanceWarningChange = async () => {
        await this.setState({balanceWarning: !this.state.balanceWarning})
        if (this.state.balanceWarning !== this.state.balanceWarningBackend) {
            await this.setState({balanceWarningSave: true})
        } else if (this.state.balanceWarning === this.state.balanceWarningBackend) {
            await this.setState({balanceWarningSave: false})
        }
    }

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
    }

    updateErrorsList2 = (error, id) => {
        let errorsList2 = this.state.errorsList2;
        errorsList2[parseInt(id) - 1] = error;
        this.setState({errorsList2})
    }

   handleSave = async () => {
       /* This two requests are used for editing Auto Top Up related values, one is for top up enabled case
        * and other is for disabled case*/
       //console.log('handle save started')
        await this.setState({spinnerActive: true, fieldsCheckActive: true})
        let projectId = await this.props.selectedSource || localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        // if (Number(this.state.topUpLimit) >= 20 && Number(this.state.topUpWith) >= 15 && this.state.autoTopUp){
        // await this.setState({fieldsCheckActive: false})
        setTimeout(async () => {
            let anyErrorActive = false;
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
            if (!anyErrorActive) {

                try {
                    let tags = await http.post('api/user/' + this.props.user.id + '/project/' + projectId + '/edit_workspace_balance', {
                        balance_threshold: parseInt(this.state.topUpLimit),
                        top_up_amount: parseInt(this.state.topUpWith),
                        notify_me_by: "",//if set otherwise null
                        top_up_enabled: this.state.autoTopUp//can be set via this call as with the previous one
                    }, {headers: {authorization: getJwt()}});
                    // console.log('new tags:', tags);
                    this.props.updateUserFromServer();
                    await this.setState({spinnerActive: false, autoTopUpSave: false})
                    toastr.success("Auto Top Up configuration is saved");
                } catch (ex) {
                    toastr.error("Error with saving Auto Top Up");
                    await this.setState({spinnerActive: false})
                }
            } else {
                await this.setState({spinnerActive: false})
            }
        }, 500)
        // }else if(this.state.autoTopUp){
        //     toastr.error("You can top up with minimum $15 and balance threshold should be at least $20.")
        //     await this.setState({spinnerActive: false})
        // }

        if (!this.state.autoTopUp) {
            // await this.setState({fieldsCheckActive: false})
            try {
                let tags = await http.post('api/user/' + this.props.user.id + '/project/' + projectId + '/top_up_balance', {
                    top_up_enabled: this.state.autoTopUp//can be set via this call as with the previous one
                }, {headers: {authorization: getJwt()}});
                // console.log('new tags:', tags);
                this.props.updateUserFromServer();
                await this.setState({spinnerActive: false, autoTopUpSave: false})
                toastr.success("Auto Top Up configuration is saved");
            } catch (ex) {
                toastr.error("Error with saving Auto Top Up");
                await this.setState({spinnerActive: false})
            }
        }
    }

    handleSave2 = async () => {
        await this.setState({fieldsCheckActive2: true})

        // await this.setState({fieldsCheckActive: false})
    }

    render() {
        return (
            <div className='add-funds-content-container'>
                <div className='white-wrapper'>
                    <h2 className='page-title'><strong>Preferences</strong></h2>
                    <div className='preferences-data-wrapper'>
                        <div className='half-container'>
                            <div className='label-text-container'>
                                <h3><strong>Workspace Balance</strong></h3>
                                <p>This is your current Workspace Balance. The Credits you top-up here never expire and
                                    are used
                                    to pay for the campaigns you run across all channels.</p>
                                <button className='btn-action'
                                        onClick={() => this.props.history.push('/top-up/add-credits')}>Add Credits
                                        {/*onClick={()=>this.setState({stripeReplacementModal: true})}>Add Credits*/}
                                </button>
                            </div>
                        </div>
                        <div className='half-container'>
                            <div className='balance-container'>
                                <p className='balance-credit'>{this.props.projectBalance && this.props.projectBalance.credits ?
                                    Number(this.props.projectBalance.credits).toFixed(2) :
                                    '0.00'
                                }</p>
                                <p>Workspace Credits</p>
                            </div>
                        </div>
                    </div>
                    {
                        this.props.viberActive ?
                            <div className='preferences-data-wrapper'>
                                <div className='half-container'>
                                    <div className='label-text-container'>
                                        <h3><strong>Viber Monthly Prepaid Credits</strong></h3>
                                        <p>These are the remaining credits on your Viber Business monthly subscription,
                                            that expire
                                            at the end of this month. When you run a Viber Campaign this Balance will be
                                            used first. </p>
                                    </div>
                                </div>
                                <div className='half-container'>
                                    <div className='balance-container viber'>
                                        <p className='balance-credit'>{this.props.viberCredit ? this.props.viberCredit : 0.00}</p>
                                        <p>Viber Monthly Prepaid Credits</p>
                                    </div>
                                </div>
                            </div>
                            :
                            ''
                    }
                    <div className='preferences-data-wrapper'>
                        <div className='toggle-container'>
                            <Switch checked={this.state.autoTopUp} onChange={this.handleAutoTopUpChange}/>
                            <div className='label-text-container'>
                                <h3><strong>Auto Top Up</strong></h3>
                                <p>Automatically recharge your account through your default payment method anytime your
                                    balance runs below the listed amount.</p>
                            </div>
                        </div>
                        <div className='input-container'>
                            <div style={{margin: '0 0 10px 0'}}>
                                {
                                    this.state.autoTopUp ?
                                        <InputRegular
                                            className={this.state.autoPush ? '' : 'input-disabled'}
                                            id="1"
                                            label1="When Balance Falls Below"
                                            placeholder="1000"
                                            type='value-below'
                                            valueBelow={1000}
                                            min={1000}
                                            disabled={!this.state.autoTopUp}
                                            onChange={value => this.setState({
                                                topUpLimit: value,
                                                autoTopUpSave: true
                                            })}
                                            value={this.state.topUpLimit.toString()}
                                            required={true}
                                            fieldsCheckActive={this.state.fieldsCheckActive}
                                            updateErrorsList={this.updateErrorsList}
                                            errorMessage="Amount can't be less than 1000"
                                        />
                                        :
                                        <InputRegular
                                            className={this.state.autoPush ? '' : 'input-disabled'}
                                            id="1"
                                            label1="When Balance Falls Below"
                                            label2=" "
                                            placeholder="1000"
                                            value={''}
                                            type='value-below'
                                            disabled={true}
                                            required={false}
                                        />
                                }
                            </div>
                            <div style={{margin: '0 0 10px 0'}}>
                                {
                                    this.state.autoTopUp ?
                                        <InputRegular
                                            className={this.state.autoPush ? '' : 'input-disabled'}
                                            id="2"
                                            label1="Top Up With"
                                            placeholder="$15"
                                            type='value-below'
                                            valueBelow={1000}
                                            disabled={!this.state.autoTopUp}
                                            onChange={value => this.setState({topUpWith: value, autoTopUpSave: true})}
                                            value={this.state.topUpWith.toString()}
                                            required={true}
                                            fieldsCheckActive={this.state.fieldsCheckActive}
                                            updateErrorsList={this.updateErrorsList}
                                            min={1000}
                                            errorMessage="Amount can't be less than 1000"
                                        />
                                        :
                                        <InputRegular
                                            className={this.state.autoPush ? '' : 'input-disabled'}
                                            id="2"
                                            label1="Top Up With"
                                            label2=" "
                                            placeholder="1000"
                                            value=''
                                            type='value-below'
                                            disabled={true}
                                            required={false}
                                        />
                                }
                            </div>
                            {this.state.autoTopUpSave ?
                                <div className='align-right'>
                                    {
                                        this.state.spinnerActive ?
                                            <button className="btn-action btn-spinner" disabled={true}>Save <i
                                                className='fa fa-spin fa-spinner'></i></button>
                                            :
                                            <button className='btn-action' onClick={this.handleSave}>Save</button>
                                    }
                                </div>
                                :
                                ''
                            }
                        </div>
                    </div>
                    {process.env.REACT_APP_ENVIRONMENT === 'DEV' ?
                        <div className='preferences-data-wrapper'>
                            <div className='toggle-container'>
                                {/*<Switch checked={this.state.balanceWarning} onChange={this.handleBalanceWarningChange} />*/}
                                <Switch checked={this.state.balanceWarning}
                                        onChange={() => console.log('balance warning disabled')}/>
                                <div className='label-text-container' style={{opacity: 0.5}}>
                                    <h3><strong>Balance Warning</strong></h3>
                                    <p>Send an email or SMS anytime your balance runs bellow the listed amount</p>
                                </div>
                            </div>
                            <div className='input-container'>
                                <div style={{margin: '0 0 10px 0'}}>
                                    <InputRegular
                                        id="1"
                                        label1="When Balance Falls Below"
                                        placeholder="$20"
                                        type='value-below'
                                        valueBellow={20}
                                        disabled={!this.state.balanceWarning}
                                        onChange={value => this.setState({balanceWarningLimit: value})}
                                        value={this.state.balanceWarningLimit}
                                        required={true}
                                        fieldsCheckActive={this.state.fieldsCheckActive2}
                                        updateErrorsList={this.updateErrorsList2}
                                        errorMessage="Amount can't be empty"
                                    />
                                </div>
                                <div style={{margin: '0 0 25px 0'}}>
                                    <Select
                                        items={['Email & SMS', 'Email', 'Sms']}
                                        itemRenderer={(item, index) => <MenuItem
                                            key={index}
                                            onClick={() => this.setState({notifyMeBy: item})}
                                            text={item}
                                        />}
                                        filterable={false}
                                        resetOnClose={true}
                                        disabled={!this.state.balanceWarning}
                                    >
                                        <p
                                            style={{
                                                fontSize: 12,
                                                marginBottom: 0
                                            }} className={!this.state.balanceWarning ? 'disabled-label' : ''}>Notify Me
                                            By</p>
                                        <Button
                                            className={!this.state.balanceWarning ? 'country-selector-disabled' : this.state.country === 'Select Country' ? 'country-selector-empty' : 'country-selector'}
                                            text={this.state.notifyMeBy}
                                            rightIcon="caret-down">
                                        </Button>

                                    </Select>
                                </div>
                                {
                                    this.state.balanceWarningSave ?
                                        <div className='align-right'>
                                            <button className='btn-action' onClick={this.handleSave2}>Save</button>
                                        </div>
                                        :
                                        ''
                                }
                            </div>
                        </div>
                        :
                        ''
                    }
                </div>
                {/*<StripeReplacementModal*/}
                {/*    showModal={this.state.stripeReplacementModal}*/}
                {/*    handleClose={() => this.setState({stripeReplacementModal: false})}*/}
                {/*    maxWidth={600}*/}
                {/*    history={this.props.history}*/}
                {/*    user={this.props.user}*/}
                {/*    updateUserFromServer={this.props.updateUserFromServer}*/}
                {/*/>*/}
            </div>
        )
    }
}

export default BillingPreferences;